import { render } from "./Product.vue?vue&type=template&id=11bcbd66&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "@/assets/css/layout_product.css?vue&type=style&index=0&id=11bcbd66&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bcbd66"]])

export default __exports__